import { getCookie } from '@utiljs/cookie';
import React, { useEffect, useState } from 'react';

const Page: React.FC<{ url: string }> = props => {
    const { url: baseUrl = '' } = props;
    const [url, setUrl] = useState('');
    useEffect(() => {
        const cookies = {
            b_token: getCookie('b_token'),
            a_id: getCookie('a_id'),
            serviceProviderID: getCookie('serviceProviderID'),
            device_uuid: getCookie('device_uuid'),
            e_parent_acct_id: getCookie('e_parent_acct_id'),
        };

        const queryStr = Object.entries(cookies)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&');
        setUrl(`${baseUrl}?${queryStr}`);
    }, [baseUrl]);
    return (
        <div className="main-content">
            <iframe src={url} frameBorder="no" width="100%" height="100%" />
        </div>
    );
};

export default Page;
